import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const ThemeMode = {
  Light: 'light',
  Dark: 'dark',
} as const;

export type ThemeMode = (typeof ThemeMode)[keyof typeof ThemeMode];

type ThemePreferenceState = {
  mode: ThemeMode;
  setMode: (mode: ThemeMode) => void;
  toggle: () => void;
};

export const useThemePreference = create<ThemePreferenceState>()(
  persist(
    (set) => ({
      mode: ThemeMode.Light,
      setMode: (mode) => set({ mode }),
      toggle: () => set((s) => ({ mode: s.mode === ThemeMode.Dark ? ThemeMode.Light : ThemeMode.Dark })),
    }),
    { name: 'cult-theme' },
  ),
);
